(function () {

  var MOBILE_BP = 750; // px

  /* ─────────────────────────────────────────────────────────────────────
     Десктоп: точки-индикаторы для thumbnail / thumbnail_slider layout
  ───────────────────────────────────────────────────────────────────── */
  function initGalleryCustom() {
    var galleries = document.querySelectorAll(
      '.product--thumbnail media-gallery, .product--thumbnail_slider media-gallery'
    );

    galleries.forEach(function (gallery) {
      var viewerComponent = gallery.querySelector('[id^="GalleryViewer"]');
      var thumbsComponent = gallery.querySelector('[id^="GalleryThumbnails"]');
      if (!viewerComponent) return;

      var slides = Array.from(viewerComponent.querySelectorAll('.product__media-item[data-media-id]'));
      if (slides.length < 2) return;

      var dotsWrapper = document.createElement('div');
      dotsWrapper.className = 'pdp-gallery-dots';

      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'pdp-gallery-dot' + (i === 0 ? ' is-active' : '');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.dataset.index = i;
        dotsWrapper.appendChild(dot);
      });

      viewerComponent.appendChild(dotsWrapper);

      function updateDots(mediaId) {
        var idx = slides.findIndex(function (s) { return s.dataset.mediaId === mediaId; });
        if (idx === -1) return;
        dotsWrapper.querySelectorAll('.pdp-gallery-dot').forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }

      viewerComponent.addEventListener('slideChanged', function (e) {
        var currentEl = e.detail && e.detail.currentElement;
        if (!currentEl) return;
        updateDots(currentEl.dataset.mediaId);
      });

      dotsWrapper.addEventListener('click', function (e) {
        var dot = e.target.closest('.pdp-gallery-dot');
        if (!dot) return;
        var idx = parseInt(dot.dataset.index, 10);
        var targetSlide = slides[idx];
        if (!targetSlide) return;
        gallery.setActiveMedia(targetSlide.dataset.mediaId, false);
      });

      if (typeof gallery.setActiveMedia === 'function') {
        var _origSetActiveMedia = gallery.setActiveMedia.bind(gallery);
        gallery.setActiveMedia = function (mediaId, prepend) {
          _origSetActiveMedia(mediaId, prepend);
          updateDots(mediaId);
        };
      }

      if (thumbsComponent && typeof gallery.setActiveThumbnail === 'function') {
        gallery.setActiveThumbnail = function (thumbnail) {
          if (!thumbnail) return;
          thumbsComponent.querySelectorAll('button').forEach(function (btn) {
            btn.removeAttribute('aria-current');
          });
          var btn = thumbnail.querySelector('button');
          if (btn) btn.setAttribute('aria-current', 'true');
          var list = thumbsComponent.querySelector('.thumbnail-list');
          if (list) list.scrollTo({ top: thumbnail.offsetTop, behavior: 'smooth' });
        };
      }
    });
  }

  /* ─────────────────────────────────────────────────────────────────────
     Десктоп: кастомные стрелки для thumbnail / thumbnail_slider layout
  ───────────────────────────────────────────────────────────────────── */
  function initCustomArrows() {
    var galleries = document.querySelectorAll(
      '.product--thumbnail media-gallery, .product--thumbnail_slider media-gallery'
    );

    galleries.forEach(function (gallery) {
      var viewerComponent = gallery.querySelector('[id^="GalleryViewer"]');
      if (!viewerComponent) return;

      var slides = Array.from(viewerComponent.querySelectorAll('.product__media-item[data-media-id]'));
      if (slides.length < 2) return;

      var prevBtn = viewerComponent.querySelector('.slider-button--prev');
      var nextBtn = viewerComponent.querySelector('.slider-button--next');
      if (!prevBtn || !nextBtn) return;

      function getCurrentIndex() {
        return slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      }

      function goTo(idx) {
        if (idx < 0) idx = slides.length - 1;
        if (idx >= slides.length) idx = 0;
        if (typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(slides[idx].dataset.mediaId, false);
        }
      }

      prevBtn.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        goTo(getCurrentIndex() - 1);
      }, true);

      nextBtn.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        goTo(getCurrentIndex() + 1);
      }, true);
    });
  }

  /* ─────────────────────────────────────────────────────────────────────
     Мобайл: превью-миниатюры 30×30
     - DOM создаётся один раз
     - видимость управляется классом .is-visible через ResizeObserver
     - при переходе десктоп→мобайл и обратно не ломает верстку
  ───────────────────────────────────────────────────────────────────── */
  function initMobileThumbs() {
    var galleries = document.querySelectorAll('media-gallery');

    galleries.forEach(function (gallery) {
      var viewerComponent = gallery.querySelector('[id^="GalleryViewer"]');
      if (!viewerComponent) return;

      var slides = Array.from(viewerComponent.querySelectorAll('.product__media-item[data-media-id]'));
      if (slides.length < 2) return;

      // ── Создаём DOM превью один раз ──────────────────────────────────
      var thumbsWrapper = viewerComponent.querySelector('.pdp-mobile-thumbs');
      if (!thumbsWrapper) {
        thumbsWrapper = document.createElement('div');
        thumbsWrapper.className = 'pdp-mobile-thumbs';

        slides.forEach(function (slide, i) {
          var sourceImg = slide.querySelector('img');

          var btn = document.createElement('button');
          btn.className = 'pdp-mobile-thumb' + (i === 0 ? ' is-active' : '');
          btn.type = 'button';
          btn.setAttribute('aria-label', 'Slide ' + (i + 1));
          btn.dataset.mediaId = slide.dataset.mediaId;

          if (sourceImg) {
            var img = document.createElement('img');
            img.src = sourceImg.currentSrc || sourceImg.src || sourceImg.dataset.src || '';
            img.alt = sourceImg.alt || '';
            img.loading = 'lazy';
            btn.appendChild(img);
          }

          thumbsWrapper.appendChild(btn);
        });

        viewerComponent.appendChild(thumbsWrapper);

        // ── Обновление активной превью ──────────────────────────────
        function updateMobileThumbs(mediaId) {
          thumbsWrapper.querySelectorAll('.pdp-mobile-thumb').forEach(function (btn) {
            btn.classList.toggle('is-active', btn.dataset.mediaId === mediaId);
          });
        }

        // slideChanged от Dawn
        viewerComponent.addEventListener('slideChanged', function (e) {
          var currentEl = e.detail && e.detail.currentElement;
          if (!currentEl) return;
          updateMobileThumbs(currentEl.dataset.mediaId);
        });

        // IntersectionObserver — fallback для нативного swipe
        var sliderList = viewerComponent.querySelector('[id^="Slider-Gallery"]');
        if (sliderList) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                var mediaId = entry.target.dataset.mediaId;
                if (mediaId) updateMobileThumbs(mediaId);
              }
            });
          }, { root: sliderList, threshold: 0.5 });

          slides.forEach(function (slide) { io.observe(slide); });
        }

        // Клик по превью
        thumbsWrapper.addEventListener('click', function (e) {
          var btn = e.target.closest('.pdp-mobile-thumb');
          if (!btn) return;
          var mediaId = btn.dataset.mediaId;
          if (!mediaId) return;

          if (typeof gallery.setActiveMedia === 'function') {
            gallery.setActiveMedia(mediaId, false);
          } else {
            var target = slides.find(function (s) { return s.dataset.mediaId === mediaId; });
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }

          updateMobileThumbs(mediaId);
        });

        // Патчим setActiveMedia для синхронизации при программной смене
        if (typeof gallery.setActiveMedia === 'function') {
          var _orig = gallery.setActiveMedia.bind(gallery);
          gallery.setActiveMedia = function (mediaId, prepend) {
            _orig(mediaId, prepend);
            updateMobileThumbs(mediaId);
          };
        }
      }

      // ── Управление видимостью через ResizeObserver ────────────────────
      // .is-visible добавляется/убирается при каждом изменении ширины окна.
      // CSS показывает .is-visible только при max-width: 749px —
      // поэтому на десктопе враппер всё равно скрыт даже с классом.
      function syncVisibility() {
        var isMobile = window.innerWidth < MOBILE_BP;
        thumbsWrapper.classList.toggle('is-visible', isMobile);
      }

      // Первичная установка
      syncVisibility();

      // Следим за изменением размера
      if (window.ResizeObserver) {
        // Наблюдаем за самим viewerComponent — точнее чем window resize
        var ro = new ResizeObserver(function () {
          syncVisibility();
        });
        ro.observe(viewerComponent);
      } else {
        // Fallback для старых браузеров
        window.addEventListener('resize', syncVisibility);
      }
    });
  }

  /* ─────────────────────────────────────────────────────────────────────
     Инициализация
  ───────────────────────────────────────────────────────────────────── */
  function init() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        initGalleryCustom();
        initCustomArrows();
        initMobileThumbs();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
